/**
 * Évite d'afficher deux fois la même moto sur le nuage (ex. MotoScout stock + Anibis).
 */

function hostKind(url) {
  const u = String(url || '').toLowerCase()
  if (u.includes('anibis.ch')) return 'anibis'
  if (u.includes('autoscout24')) return 'motoscout'
  return 'other'
}

/**
 * @param {{ km, prix, annee?, url? }} point
 * @param {{ km, prix, annee?, url? }} vehicle — « votre » annonce (point bleu)
 * @param {string} [recordUrl] — URL de l'annonce affichée
 */
export function isScatterDuplicateOfVehicle(point, vehicle, recordUrl = '') {
  if (!point || !vehicle) return false
  const pKm = Number(point.km)
  const pPrix = Number(point.prix)
  const hKm = Number(vehicle.km)
  const hPrix = Number(vehicle.prix)
  if (!Number.isFinite(pKm) || !Number.isFinite(pPrix) || !Number.isFinite(hKm) || !Number.isFinite(hPrix)) {
    return false
  }

  const pointUrl = String(point.url || '')
  const recUrl = String(recordUrl || vehicle.url || '')
  if (recUrl && pointUrl && recUrl === pointUrl) return true

  const py = point.annee != null ? Number(point.annee) : null
  const hy = vehicle.annee != null ? Number(vehicle.annee) : null
  const yearOk =
    hy == null ||
    py == null ||
    py === hy ||
    (Number.isFinite(py) && Number.isFinite(hy) && Math.abs(py - hy) <= 1)

  const kmTol = Math.max(600, hKm * 0.07)
  const prixTol = Math.max(350, hPrix * 0.07)
  const kmClose = Math.abs(pKm - hKm) <= kmTol
  const prixClose = Math.abs(pPrix - hPrix) <= prixTol

  if (!yearOk || !prixClose) return false

  const recHost = hostKind(recUrl)
  const ptHost = hostKind(pointUrl)
  // Même moto sur deux portails : le km affiché peut diverger (ex. Anibis vs MotoScout).
  if (recHost !== 'other' && ptHost !== 'other' && recHost !== ptHost) return true

  return kmClose
}

/** Filtre les points marché qui dupliquent le véhicule ciblé. */
export function filterScatterMarketPoints(points, vehicle, recordUrl) {
  if (!Array.isArray(points) || !vehicle) return points || []
  return points.filter((p) => !isScatterDuplicateOfVehicle(p, vehicle, recordUrl))
}
